import { CommentEN } from "./comment/en";
import { EditorEN } from "./editor/en";
import { DocumentEN } from "./document/en";
import { ActionBarEN } from "./action-bar/en";
import { TimeKeepingEN } from "./layout/setting/timekeeping/en";

export const CommonEN = {
  common: {
    noExists: "No exist",
    noData: "No Data",
    description: "Description",
    goBackModal:
      "Do you want to keep the page after successful implementation?",
    btn: {
      delete: "Delete",
      cancel: "Cancel",
      no: "No",
    },
    empty: {
      record: "record",
      shiftWork: "shift work data",
      timekeeping: "timekeeping data",
      shiftAssignment: "shift assignment",
      autoTimeKeeping: "automatic timekeeping",
      leave: "leave data",
      payroll: "payroll data",
      payrollConfig: "payroll configuration",
      payrollCustom: "payroll custom",
      shiftConfig: "work shift",
      leaveConfig: "leave configuration",
      locationCheckIn: "check-in location configuration",
      notFoundRecord: "Currently, there is no {{module}}.",
      click: "Click here to ",
      searchEmpty: " does not match any {{title}}.",
      tryAgain: "Please try again",
    },
    showAgain: "Don't show again",
    required: "is required!",

    all: "All",

    add: "Create",
    update: "Update",
    import: "Import",
    importAndSave: "Import and Save",
    delete: "Delete",
    recall: "Recall",
    recallConfirm: "Are you sure you want to Recall {{name}} {{module}} ?",
    confirm_action: "Are you sure you want to {{action}} {{module}}?",
    youHave: "You have",
    title_confirm: "Confirm ",
    shift: "shift",
    payroll: "payroll",
    success: "successfully",
    recallMessage: "You have successfully submitted a revocation request!",
    create: "Create",
    cancel: "Cancel",
    yes: "Yes",
    no: "No",
    agree: "Agree",
    addField: "Add field",
    addAndSend: "Create and send",
    updateAndSend: "Update and send",
    enable: "Enable",
    disable: "Disable",
    approvalButton: "Approval",

    validate: {
      required: "is required!",
    },
    pending: "Pending",
    approved: "Approved",
    completed: "Completed",
    trashed: "Trashed",
    actived: "Actived",
    active: "Active",
    inactive: "Inactive",
    inactived: "Inactived",
    expired: "Expired",
    denied: "Denied",
    incomplete: "Incomplete",
    doing: "Doing",
    unevaluated: "Unevaluated",
    evaluated: "Evaluated",
    draft: "Draft",
    storage: "Storage",
    status: "Status",
    changed: " Changed",
    back: "Back",
    backHome: "Back Home",
    title403: "Sorry, you are not authorized to access this page.",
    title404: "Sorry, the page you visited does not exist.",
    title500: "Sorry, something went wrong !",
    default: "default",

    message: {
      add: "Create successfully",
      update: "update successfully",
      delete: "Delete successfully",
      deleteAsk: "Are you want to delete?",
    },
    labelCurrent: {
      null: "Does not exist",
    },
    timeKeeping: {
      otherJobTitle: "Other (Employee without position)",
      dayWork: "Work",
      checkinWork: "Check-in",
      day: "Day",
      sumDayWork: "Total work",
      sumWorkHour: "Total work hours",
      workHour: "Work hour",
      night: "Night",
      workDay: "Daytime",
      checkinFingerprint: "Fingerprint check-in",
      workHourValid: "Valid work hours",
      workHourCompensatory: "Compensatory work hours",
      overtimeCompensatory: "Overtime hours counted for compensatory leave",
      leaveFrom: "Leave from",
      to: "to",
      compensationDay: "Compensatory workday registration",
      reason: "Reason",
      place: "Place",
      time: "Time",
      fined: "Fined",
      notFined: "Not fined",
      late: "Late",
      leave: "Leave early",
      shift: "Shift",
      shiftWork: "Work shift",
      shiftWorkLeave: "Shift leave",
      shiftWorkCompensatory:
        "Work will be added to the corresponding compensatory day",
      sumWorkInDay: "Total work in the day",
      checkinFingerprintInDay: "Fingerprint check-in list for the day",
      notCheckinFingerprint: "No fingerprint check-in for the day",
      shiftWorkInDay: "Work shifts for the day",
      countHour: "Number of hours",
      countShift: "Number of shifts",
      checkin: "Check-in",
      workUnit: "Work unit",
      calWorkDay: "Actual work",
      numberWorkdayAuto: "Standard work",
      calWorkHour: "Calculated work hours",
      countNumberWorkdayAuto: "Number of standard workdays",
      countLate: "Number of late instances",
      countLeave: "Number of early leave instances",
      lateMinute: "Number of late minutes",
      leaveMinute: "Number of early leave minutes",
      calWorkdayLeaveNoReason: "Workday leave without reason",
      noCheckInOut: "Number of missed check-ins/outs",
      calWorkHourNight: "Calculated night work hours",
      calWorkHourLight: "Calculated daytime work hours",
      calWorkHourOverTime: "Calculated overtime work hours",
      workdayOverTime: "Actual overtime work",
      calMealDayOvertime: "Meal during overtime",
      calMealDayShift: "Meal during shift",
      calMealDay: "Meal",
      calFineLate: "Late penalty",
      calFineLeave: "Early leave penalty",
      calFineLeaveNoReason: "Leave without reason penalty",
      calFineNoCheckInOut: "Missed check-in/out penalty",
      calFine: "Attendance penalty",
      calWorkLate: "Work penalty for being late",
      calWorkdayLeave: "Work penalty for early leave",
      countCalWorkdayLeaveNoReason: "Penalty for leave without reason",
      calWorkdayNoCheckInOut: "Penalty for missed check-in/out",
    },
  },

  ...CommentEN,
  ...EditorEN,
  ...DocumentEN,
  ...ActionBarEN,
  ...TimeKeepingEN,
};
